<h3 mat-dialog-title class="semi-bold">{{ title | translate }}</h3>
<div mat-dialog-content>
    <p class="mt--none">{{ 'App.AccountNumber.Labels.Instructions' | translate }}</p>
    <img src="./img/find-account-number.png" alt="Find account number" width="100%" />
</div>
<div mat-dialog-actions>
    <div class="row column--12 justify-content-center">
        <div class="row column--12 justify-content-center">
            <button mat-button class="secondary-button rounded mt--sm" (click)="closeDialog()">
              {{ 'App.StatusHistory.Labels.Close' | translate }}
            </button>
        </div>
    </div>
</div>